import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import { createStore, applyMiddleware } from 'redux';

import rootReducer from './reducer';

const logger = createLogger({});

const store = createStore(
    rootReducer,
    applyMiddleware(
        promiseMiddleware
    )
)

export default store;